import { render, staticRenderFns } from "./LayoutEmpty.vue?vue&type=template&id=4605984f"
import script from "./LayoutEmpty.vue?vue&type=script&lang=js"
export * from "./LayoutEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4605984f')) {
      api.createRecord('4605984f', component.options)
    } else {
      api.reload('4605984f', component.options)
    }
    module.hot.accept("./LayoutEmpty.vue?vue&type=template&id=4605984f", function () {
      api.rerender('4605984f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/_layouts/layout-empty/LayoutEmpty.vue"
export default component.exports